import _classCallCheck from "/tmp/264ea0a6/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/264ea0a6/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { StyleSheet } from 'react-native';
import Style from './style';
import utils from './utils';
import vars from './replacers/vars';
import mediaQueries from './replacers/media-queries';

var _default =
/*#__PURE__*/
function () {
  /**
   * Constructor
   * @param {Object} source
   */
  function _default(source) {
    _classCallCheck(this, _default);

    this.source = source;
    this.result = Object.create(null);
    this.cache = new Map(); // cache result for each theme

    this.nativeSheet = {};
    this.globalVars = null;
    this.localVars = null;
    this.allVars = null;
    this.processedSource = null;
  }
  /**
   * Calculates sheet and update result
   * @param {Object} globalVars
   */


  _createClass(_default, [{
    key: "calc",
    value: function calc(globalVars) {
      this.globalVars = globalVars;
      this.clearResult();

      if (this.hasCache()) {
        this.applyCache();
      } else {
        this.processMediaQueries();
        this.calcVars();
        this.calcStyles();
        this.calcNative();
        this.storeCache();
      }

      return this.getResult();
    }
  }, {
    key: "processMediaQueries",
    value: function processMediaQueries() {
      this.processedSource = mediaQueries.process(this.source);
    }
  }, {
    key: "calcVars",
    value: function calcVars() {
      var rawLocalVars = vars.extract(this.processedSource);

      if (rawLocalVars) {
        this.localVars = new Style(rawLocalVars, [rawLocalVars, this.globalVars]).calc().calculatedVars;
        Object.assign(this.result, this.localVars);
      } else {
        this.localVars = null;
      }

      this.allVars = [this.localVars, this.globalVars].filter(Boolean);
    }
  }, {
    key: "calcStyles",
    value: function calcStyles() {
      var _this = this;

      var extractedStyles = utils.excludeKeys(this.processedSource, this.localVars);
      Object.keys(extractedStyles).forEach(function (key) {
        var styles = extractedStyles[key];

        if (typeof styles === 'function') {
          styles = styles();
        }

        if (styles && typeof styles === 'object') {
          _this.calcStyle(key, styles);
        } else {
          // copy primitive values to result as-is
          _this.result[key] = styles;
        }
      });
    }
  }, {
    key: "calcStyle",
    value: function calcStyle(key, styleProps) {
      var style = new Style(styleProps, this.allVars);

      var _style$calc = style.calc(),
          calculatedProps = _style$calc.calculatedProps,
          calculatedVars = _style$calc.calculatedVars;

      var merged = Object.assign({}, calculatedVars, calculatedProps);

      if (key.charAt(0) === '_') {
        this.result[key] = merged;
      } else {
        this.result['_' + key] = merged;
        this.nativeSheet[key] = calculatedProps;
      }
    }
  }, {
    key: "calcNative",
    value: function calcNative() {
      if (Object.keys(this.nativeSheet).length) {
        var rnStyleSheet = StyleSheet.create(this.nativeSheet);
        Object.assign(this.result, rnStyleSheet);
      }
    }
  }, {
    key: "getResult",
    value: function getResult() {
      return this.result;
    }
  }, {
    key: "clearResult",
    value: function clearResult() {
      var _this2 = this;

      Object.keys(this.result).forEach(function (key) {
        return delete _this2.result[key];
      });
    }
  }, {
    key: "hasCache",
    value: function hasCache() {
      var key = this.getCacheKey();
      return key && this.cache.has(key);
    }
  }, {
    key: "applyCache",
    value: function applyCache() {
      var cachedResult = this.cache.get(this.getCacheKey());
      Object.assign(this.result, cachedResult);
    }
  }, {
    key: "storeCache",
    value: function storeCache() {
      var key = this.getCacheKey();

      if (key) {
        this.cache.set(key, Object.assign({}, this.result));
      }
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.cache.clear();
    }
  }, {
    key: "getCacheKey",
    value: function getCacheKey() {
      return this.globalVars && this.globalVars.$theme;
    }
  }]);

  return _default;
}();

export { _default as default };